import React, { useEffect, useState, useRef } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { renderInput, renderSelect, IsNotNullOrEmptyOrUndefined, formatDateToDatePiker, getCasaMatriz, getServiciosProfecionales } from '../../util';
import {
  logOut,
  clearErrors,
  clearErrorsNuevoDocumento,
  getActividades,
  setLocalForm,
  getTipoCambioDolar,
  duplicarFactura,
  crearFactura,
  crearNotaCredito,
  crearNotaDebito,
  crearTiquete,
  setInicializarDocumento,
  crearFacturaCompra
} from '../../actions';
import { monedaTypeEnum, documentTypeEnum, messageTypeEnum, errorMessageUserEnum } from '../../enum';
import validate from './validate';
import { medioPago, tipoMoneda, condicionVenta } from '../../catalogos';
import { documentoElectronico } from '../../models/documentoElectronico';
import DatePicker, {
  formatDates,
  normalizeDates,
} from '../datePicker/DatePicker';
import Receptor from './Receptor';
import Detalle from './Detalle';
import LineasDetalle from './LineasDetalle';
import BasicMessage from '../messages/basicMessage';
import ResumenDocumento from './ResumenDocumento ';
import RenderReferenciaDocumento from '../shared/RenderReferenciaDocumento';

let tempMessageError = '';
let docTypeTemp = '';

const NuevoDocumento = (props) => {
  docTypeTemp = '';

  const { token, emisor, docType, actividadesState, localFormState,
    tipoCambioDolarState, duplicarFacturaState,
    estadoDocumentoElectronico, nuevoDocumentoErroresState, isLoading } = props;
  const [message, setMessage] = useState('');
  const [mgType, setMgType] = useState('');
  const [editarDetalle, setEditarDetalle] = useState(null);
  const [actividades, setActividades] = useState([]);
  const [condicionVentaSelected, SetCondicionVentaSelected] = useState('01');
  const formRef = useRef(null);
  const [lineaDetalleTemp, setLineaDetalleTemp] = useState([]);
  docTypeTemp = docType;
  const [actualizarTotales, setActualizarTotales] = useState(false);

  useEffect(() => {
    if (token !== null && emisor) {

      props.setLocalForm({
        ...documentoElectronico,
        Clave: "",
        NumeroConsecutivo: getCasaMatriz(emisor.usuario),
        Emisor: emisor,
        FechaEmision: new Date(),
        CondicionVenta: '01',
        PlazoCredito: 0,
        MedioPago: '01',
        Receptor: {
          ...documentoElectronico.Receptor,
          EmisorId: emisor.Id,
        },
        InformacionReferencia: setInformacionReferencia(null, null, null),
        ResumenFactura: {
          ...documentoElectronico.ResumenFactura,
        }
      });

      props.getActividades(token, emisor.Identificacion.Numero);

    }
    return () => {
      props.setInicializarDocumento();
      setLineaDetalleTemp([]);
    }

  }, []);


  useEffect(() => {
    if (actividadesState?.actividades && localFormState !== null && actividades?.length === 0) {
      const actividadItems = [];

      actividadesState.actividades.map(item => {
        actividadItems.push({ value: item.CodigoActividad, display: item.Actividad });
      });

      setActividades(actividadItems);

      props.setLocalForm({
        ...localFormState,
        CodigoActividad: actividadItems[0]?.value,
      });


    }
  }, [actividadesState, localFormState]);

  useEffect(() => {

    if (tipoCambioDolarState?.tipoCambioDolar?.venta
      && localFormState?.ResumenFactura
      && !isLoading) {

      props.setLocalForm({
        ...localFormState,
        ResumenFactura: {
          ...localFormState.ResumenFactura,
          CodigoTipoMoneda: {
            CodigoMoneda: monedaTypeEnum.Dolar,
            TipoCambio: tipoCambioDolarState?.tipoCambioDolar.venta
          },
        }
      });
    }

  }, [tipoCambioDolarState, isLoading]);

  useEffect(() => {
    if (duplicarFacturaState && duplicarFacturaState !== null && !isLoading) {

      const { Receptor, DetalleServicio, CodigoActividad, PlazoCredito, MedioPago, CondicionVenta, ResumenFactura, Clave, FechaEmision } = duplicarFacturaState;
      let indexLinea = 0;
      DetalleServicio.LineaDetalle.map(item => item.NumeroLinea = (++indexLinea));

      const informacionReferencia = setInformacionReferencia(Clave, FechaEmision, duplicarFacturaState.InformacionReferencia);

      props.setLocalForm({
        ...duplicarFacturaState,
        CodigoActividad: CodigoActividad,
        Receptor: (docType === documentTypeEnum.FacturaCompra ? emisor : Receptor),
        PlazoCredito: PlazoCredito,
        MedioPago: MedioPago,
        CondicionVenta: CondicionVenta,
        FechaEmision: new Date(),
        DetalleServicio: {
          LineaDetalle: [...DetalleServicio.LineaDetalle],
        },
        Receptor: {
          ...duplicarFacturaState.Receptor,
          EmisorId: emisor.Id,
        },
        ResumenFactura: {
          ...ResumenFactura,
          CodigoTipoMoneda: {
            CodigoMoneda: ResumenFactura.CodigoTipoMoneda.CodigoMoneda,
            TipoCambio: ResumenFactura.CodigoTipoMoneda.TipoCambio
          },
        },

        InformacionReferencia: informacionReferencia
      });

      props.duplicarFactura(null);

      setLineaDetalleTemp([...DetalleServicio.LineaDetalle]);
    }

  }, [duplicarFacturaState, isLoading]);

  useEffect(() => {

    if (estadoDocumentoElectronico && !duplicarFacturaState) {
      props.setLocalForm({
        ...documentoElectronico,
        Clave: "",
        NumeroConsecutivo: getCasaMatriz(emisor.usuario),
        Emisor: emisor,
        FechaEmision: new Date(),
        CondicionVenta: '01',
        PlazoCredito: 0,
        MedioPago: '01',
        Receptor: {
          ...documentoElectronico.Receptor,
          EmisorId: emisor.Id,
        },
        InformacionReferencia: setInformacionReferencia(null, null, null),
        ResumenFactura: {
          ...documentoElectronico.ResumenFactura,
        }
      });
    }

    if (nuevoDocumentoErroresState && IsNotNullOrEmptyOrUndefined(nuevoDocumentoErroresState.error)) {
      setMgType(nuevoDocumentoErroresState?.error ? messageTypeEnum.error : messageTypeEnum.success);
      setMessage(nuevoDocumentoErroresState.message);
    } else {
      setMgType('');
    }

  }, [estadoDocumentoElectronico, nuevoDocumentoErroresState]);

  useEffect(() => {
    if (IsNotNullOrEmptyOrUndefined(localFormState?.DetalleServicio) && IsNotNullOrEmptyOrUndefined(localFormState?.ResumenFactura)) {
      setActualizarTotales(true);
    }
  }, [localFormState?.DetalleServicio, localFormState?.ResumenFactura])

  useEffect(() => {

    if (lineaDetalleTemp !== null && localFormState !== null) {
      props.setLocalForm({
        ...localFormState,
        DetalleServicio: {
          LineaDetalle: [...lineaDetalleTemp],
        }
      });
    }

  }, [lineaDetalleTemp])

  const setInformacionReferencia = (clave, fechaEmision, informacionReferencia) => {

    let InformacionReferenciaTemp = {
      Numero: null,
      Razon: null,
      Codigo: null,
      TipoDoc: null,
      FechaEmision: null
    }

    switch (docType) {
      case documentTypeEnum.NotaCredito:
        InformacionReferenciaTemp.Numero = clave;
        InformacionReferenciaTemp.Codigo = "01";
        InformacionReferenciaTemp.TipoDoc = "03";
        informacionReferencia?.Razon
          ? InformacionReferenciaTemp.Razon = informacionReferencia?.Razon
          : InformacionReferenciaTemp.Razon = null;
        InformacionReferenciaTemp.FechaEmision = fechaEmision;
        return InformacionReferenciaTemp;

      case documentTypeEnum.NotaDebito:
        InformacionReferenciaTemp.Numero = clave;
        InformacionReferenciaTemp.Codigo = "99";
        InformacionReferenciaTemp.TipoDoc = "99";

        informacionReferencia?.Razon
          ? InformacionReferenciaTemp.Razon = informacionReferencia?.Razon
          : InformacionReferenciaTemp.Razon = null;

        InformacionReferenciaTemp.FechaEmision = fechaEmision;
        return InformacionReferenciaTemp;

      case documentTypeEnum.Factura:
        if (IsNotNullOrEmptyOrUndefined(informacionReferencia)) {
          return InformacionReferenciaTemp = informacionReferencia;
        } else {
          InformacionReferenciaTemp.Numero = null;
          InformacionReferenciaTemp.Razon = null;
          InformacionReferenciaTemp.Codigo = "04";
          InformacionReferenciaTemp.TipoDoc = "99";
          InformacionReferenciaTemp.FechaEmision = formatDateToDatePiker(moment.now());
        }
        return InformacionReferenciaTemp;

      case documentTypeEnum.FacturaCompra:
        if (IsNotNullOrEmptyOrUndefined(informacionReferencia)) {
          return InformacionReferenciaTemp = informacionReferencia;
        } else {
          InformacionReferenciaTemp.Numero = null;
          InformacionReferenciaTemp.Razon = null;
          InformacionReferenciaTemp.Codigo = "04";
          InformacionReferenciaTemp.TipoDoc = "99";
          InformacionReferenciaTemp.FechaEmision = formatDateToDatePiker(moment.now());
        }
        return InformacionReferenciaTemp;

      case documentTypeEnum.Tiquete:
        if (IsNotNullOrEmptyOrUndefined(informacionReferencia)) {
          return InformacionReferenciaTemp = informacionReferencia;
        } else {
          InformacionReferenciaTemp.Numero = null;
          InformacionReferenciaTemp.Razon = null;
          InformacionReferenciaTemp.Codigo = "04";
          InformacionReferenciaTemp.TipoDoc = "99";
          InformacionReferenciaTemp.FechaEmision = formatDateToDatePiker(moment.now());
        }
        return InformacionReferenciaTemp;

      default:
        return InformacionReferenciaTemp;
    }

  }

  const tipoCambioOnchage = (value) => {
    if (value === monedaTypeEnum.Dolar) {
      props.getTipoCambioDolar(moment().format('DD'), moment().format('MM'), moment().format('YYYY'), true);
    } else {
      props.getTipoCambioDolar(0, 0, 0, false);

      props.setLocalForm({
        ...localFormState,
        ResumenFactura: {
          ...localFormState.ResumenFactura,
          CodigoTipoMoneda: {
            CodigoMoneda: monedaTypeEnum.Colon,
            TipoCambio: 1
          },
        }
      });
    }
  };

  const condicionVentaOnchange = (value) => {

    if (value === '02') //Credito
    {
      props.setLocalForm({
        ...localFormState,
        CondicionVenta: value,
        PlazoCredito: 30
      });
    } else {
      props.setLocalForm({
        ...localFormState,
        CondicionVenta: value,
        PlazoCredito: 0,
      });
    }
    SetCondicionVentaSelected(value);
  }

  const onSelectReceptor = (receptor) => {

    props.setLocalForm({
      ...localFormState,
      Receptor: receptor,
    });
  }

  const onChangeActividadEconomica = (value) => {

    props.setLocalForm({
      ...localFormState,
      CodigoActividad: value,
    });
  }

  const getTotalDesgloseImpuesto = (impuesto, desgloseImpuestoArray) => {
    const desgloseImp = desgloseImpuestoArray.find(x => x.Codigo === impuesto[0].Codigo && x.CodigoTarifaIVA === impuesto[0].CodigoTarifa);
    if (desgloseImp) {
      let imTotal = 0;

      if (IsNotNullOrEmptyOrUndefined(impuesto[0]?.Exoneracion)) {
        imTotal = (parseFloat(desgloseImp.TotalMontoImpuesto) + (parseFloat(impuesto[0].Monto) - parseFloat(impuesto[0]?.Exoneracion.MontoExoneracion)));
      }
      else {
        imTotal = (parseFloat(desgloseImp.TotalMontoImpuesto) + parseFloat(impuesto[0].Monto));
      }

      desgloseImp.TotalMontoImpuesto = imTotal.toFixed(3);
      desgloseImpuestoArray = [
        ...desgloseImpuestoArray.filter(x => x.Codigo !== desgloseImp.Codigo && x.CodigoTarifaIVA !== desgloseImp.CodigoTarifaIVA),
        desgloseImp
      ]
    } else {
      let impTotal = 0;
      if (IsNotNullOrEmptyOrUndefined(impuesto[0]?.Exoneracion)) {
        impTotal = (parseFloat(impuesto[0].Monto) - parseFloat(impuesto[0]?.Exoneracion.MontoExoneracion));
      }
      else {
        impTotal = parseFloat(impuesto[0].Monto);
      }

      desgloseImpuestoArray.push({
        Codigo: impuesto[0].Codigo,
        CodigoTarifaIVA: impuesto[0].CodigoTarifa,
        TotalMontoImpuesto: parseFloat(impTotal).toFixed(3),
      });
    }

    return desgloseImpuestoArray;
  }

  const onSubmit = (formValues) => {

    if (lineaDetalleTemp?.length === 0) {
      setMessage(tempMessageError);
      setMgType(messageTypeEnum.error);
    } else {
      setMessage('');
      setMgType('');
      formValues = {
        ...formValues,
        Clave: null,
        NumeroConsecutivo: getCasaMatriz(emisor.usuario),
      }

      if (!formValues.InformacionReferencia?.Numero) {
        formValues = {
          ...formValues,
          InformacionReferencia: null
        }
      }

      let desgloseImpuestoArray = [];

      let lineaDetalle = formValues.DetalleServicio.LineaDetalle.map(detalle => {
        let impuestoNeto = 0;
        let impuesto = detalle.Impuestos?.Impuesto?.map(imp => {
          if (IsNotNullOrEmptyOrUndefined(imp?.Codigo)) {
            return imp;
          }
          return null;
        });


        if (impuesto && impuesto.length > 0 && IsNotNullOrEmptyOrUndefined(impuesto[0])) {
          desgloseImpuestoArray = getTotalDesgloseImpuesto(impuesto, desgloseImpuestoArray);
          let impExento = 0;
          if (IsNotNullOrEmptyOrUndefined(impuesto[0]?.Exoneracion)) {
            impExento = impuesto[0]?.Exoneracion.MontoExoneracion;
          }
          impuestoNeto = impuestoNeto + parseFloat(impuesto[0].Monto) - parseFloat(impExento);
        }

        detalle = {
          ...detalle,
          Impuestos: IsNotNullOrEmptyOrUndefined(impuesto[0]) ? { Impuesto: impuesto } : null,
          ImpuestoAsumidoEmisorFabrica: 0,
          ImpuestoNeto: impuestoNeto,
        }

        return detalle;
      });
      const totalDesgloseImpuesto = desgloseImpuestoArray?.length > 0 ? [
        ...desgloseImpuestoArray
      ] : null;

      formValues = {
        ...formValues,
        FechaEmision: formatDateToDatePiker(formValues.FechaEmision),
        DetalleServicio: {
          LineaDetalle: lineaDetalle
        },
        Emisor: { ...emisor },
        ResumenFactura: {
          ...localFormState.ResumenFactura,
          TotalDesgloseImpuesto: totalDesgloseImpuesto,
        }
      }

      switch (docType) {
        case documentTypeEnum.Factura:
          props.crearFactura(token, formValues);
          break;

        case documentTypeEnum.NotaCredito:
          props.crearNotaCredito(token, formValues);
          break;

        case documentTypeEnum.NotaDebito:
          props.crearNotaDebito(token, formValues);
          break;

        case documentTypeEnum.Tiquete:
          formValues = {
            ...formValues,
            Receptor: null,
          }
          props.crearTiquete(token, formValues);
          break;

        case documentTypeEnum.FacturaCompra:
          formValues = {
            ...formValues,
            Receptor: formValues.Emisor,
            Emisor: formValues.Receptor
          }
          props.crearFacturaCompra(token, formValues);
          break;

        default:
          return formValues;
      }

      setLineaDetalleTemp([]);

    }

  };

  const agregarDetalle = (detalle) => {
    if (IsNotNullOrEmptyOrUndefined(existeLinea(detalle.NumeroLinea))) {

      setLineaDetalleTemp(
        [
          ...lineaDetalleTemp.filter(x => x.NumeroLinea !== detalle.NumeroLinea),
          detalle,
        ]
      );

    } else {
      lineaDetalleTemp.push(detalle);

      setLineaDetalleTemp([...asignaNumeroLineas(lineaDetalleTemp)]);
    }
  };

  const existeLinea = (numLinea) => {
    return lineaDetalleTemp?.filter((item) => item.NumeroLinea === numLinea)[0];
  };

  const detalleSeleccionado = (detalle) => {
    setEditarDetalle(detalle);
  };

  const asignaNumeroLineas = (detalle) => {
    let index = 0;
    detalle.map(() => {
      index++;
      detalle[index - 1].NumeroLinea = index;
    });
    return detalle;
  };

  const eliminarDetalle = (detalle) => {
    setLineaDetalleTemp([...asignaNumeroLineas(
      [
        ...lineaDetalleTemp.filter(x => x.NumeroLinea !== detalle.NumeroLinea),
      ]
    )]);

  };

  const closeMessage = () => {
    props.clearErrorsNuevoDocumento();
  };

  const montoTipoCambioOnchage = (value) => {

    props.setLocalForm({
      ...localFormState,
      ResumenFactura: {
        ...localFormState.ResumenFactura,
        CodigoTipoMoneda: {
          CodigoMoneda: monedaTypeEnum.Dolar,
          TipoCambio: parseFloat(value)
        }
      }
    });
  }
  const enableUser = () => {
    return emisor.Activo ? 'ui button primary' : 'ui button primary disabled';
  };
  const validarUsuario = () => {
    return (emisor.Activo === errorMessageUserEnum.inActivo && <BasicMessage message={errorMessageUserEnum.error} type={messageTypeEnum.error} onClick={() => closeMessage()} />)
  };
  return (
    <div className="nuevo-documento-container">

      <form ref={formRef} className="ui form grid" onSubmit={props.handleSubmit(onSubmit)}>
        <div className="doubling two column row">
          <div className="eleven wide column">
            <Field
              label="Actividad económica Emisor"
              name="CodigoActividad"
              component={renderSelect}
              type="select"
              options={actividades}
              onChange={(e) => onChangeActividadEconomica(e.target.value)}
              required
            />
          </div>
          <div className="five wide column">
            <Field
              label="Fecha"
              name="FechaEmision"
              component={DatePicker}
              parse={normalizeDates}
              format={formatDates}
              placeholder="DD-MM-AAAA"
            />
          </div>
        </div>

        {
          (docType !== documentTypeEnum.Tiquete && localFormState?.InformacionReferencia?.TipoDoc !== '04') && (
            <Receptor token={token} emisorId={emisor.Id} onSelectReceptor={(receptor) => onSelectReceptor(receptor)} />
          )
        }

        <div className="doubling five column row">

          <div className="four wide column">
            <Field
              label="Condición de venta"
              name="CondicionVenta"
              component={renderSelect}
              type="select"
              options={condicionVenta}
              onChange={(e) => condicionVentaOnchange(e.target.value)}
            />
          </div>
          <div className="two wide column">
            <Field
              label="Plazo crédito"
              name="PlazoCredito"
              component={renderInput}
              type="number"
              disabled={condicionVentaSelected !== '02'}
            />
          </div>
          <div className="four wide column">
            <Field
              label="Medio de pago"
              name="MedioPago"
              component={renderSelect}
              type="select"
              options={medioPago}
              onChange={(e) => props.setLocalForm({
                ...localFormState,
                MedioPago: e.target.value,
              })}
            />
          </div>
          <div className="four wide column">
            <Field
              label="Tipo moneda"
              name="ResumenFactura.CodigoTipoMoneda.CodigoMoneda"
              component={renderSelect}
              type="select"
              options={tipoMoneda}
              onChange={(e) => tipoCambioOnchage(e.target.value)}
            />
          </div>
          <div className="two wide column">
            <Field
              label="Tipo de cambio"
              name="ResumenFactura.CodigoTipoMoneda.TipoCambio"
              component={renderInput}
              type="number"
              onChange={(e) => montoTipoCambioOnchage(e.target.value)}
            />
          </div>
        </div>

        <Detalle editarDetalle={editarDetalle} token={token} emisorId={emisor.Id}
          agregarDetalle={(detalle) => agregarDetalle(detalle)}
        />

        <LineasDetalle
          eliminarDetalle={(detalle) => eliminarDetalle(detalle)}
          detalleSeleccionado={(detalle) => detalleSeleccionado(detalle)}>
        </LineasDetalle>

        <div className="ui row  stackable fluid resumen-documento-container">

          <div className="column ten wide">
            <RenderReferenciaDocumento docType={docType} />
          </div>
          <div className="column six wide right aligned">
            <ResumenDocumento
              actualizarTotales={actualizarTotales}
              tipoMedioPago={localFormState?.MedioPago}
              onTotalesActualizados={() => setActualizarTotales(false)} />
          </div>

        </div>

        <div className="column sixteen wide right aligned">
          <button className={enableUser()} type="submit">Guardar</button>
        </div>

      </form>
      {validarUsuario()}
      <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />

    </div>
  )
};

const formWrapperd = reduxForm({
  form: 'nuevoDocumentoForm',
  enableReinitialize: true,
  validate: (values) => {
    const errors = validate(values, docTypeTemp);
    tempMessageError = errors?.LineaDetalle?.Message;
    return errors;
  }
})(NuevoDocumento);

const mapStateToProps = (state) => {
  return {
    localFormState: state.localFormState,
    initialValues: state.localFormState,
    errorState: state.errorState,
    actividadesState: state.actividadesState,
    tipoCambioDolarState: state.tipoCambioDolarState,
    duplicarFacturaState: state.duplicarFacturaState,
    estadoDocumentoElectronico: state.estadoDocumentoElectronicoState,
    nuevoDocumentoErroresState: state.nuevoDocumentoErroresState,
    localFormSalvando: state.localFormSalvando,
    isLoading: state.isLoadingState,
  };
}

export default connect(mapStateToProps, {
  logOut,
  clearErrors,
  clearErrorsNuevoDocumento,
  getActividades,
  setLocalForm,
  getTipoCambioDolar,
  duplicarFactura,
  crearFactura,
  crearNotaCredito,
  crearNotaDebito,
  crearTiquete,
  setInicializarDocumento,
  crearFacturaCompra,
})(formWrapperd);